"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _styles = _interopRequireDefault(require("../styles"));
var _globalSpacing = require("./../globalSpacing");
var _times = _interopRequireDefault(require("lodash/times"));
var _reduce = _interopRequireDefault(require("lodash/reduce"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _excluded = ["classes", "className", "spacing"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var GRID_SPACING_COEFFICIENT = 8;
var GRID_SPACING_STANDARD = 4; //24px

var styles = function styles() {
  // create a separate class for each available spacing class (spacing-xs-1 through
  // spacing-xs-10).

  // this is necessary because the each space increment uses
  // theme's "spacing" attribute as the multiplier for the value passed in; but we
  // want our general spacing multiplier to be a different value than our grid multipler

  // the following will produce class definitions that look like this (assuming a space
  // value of 4):
  //
  // // grid container class
  // .Grid-spacingXS4-863 {
  //     width: calc(100% + 32px);
  // }
  //
  // // grid item class
  // .Grid-spacingXS4-863 > div.grid-item {
  //     padding: 16px;
  // }
  var spacingClasses = (0, _reduce.default)((0, _times.default)(10), function (accum, value) {
    var _assign;
    var num = value + 1;
    (0, _assign2.default)(accum, (_assign = {}, _assign["spacingXS" + num] = {
      width: "calc(100% + " + GRID_SPACING_COEFFICIENT * num + "px)",
      margin: "-" + GRID_SPACING_COEFFICIENT * num / 2 + "px",
      '& > div.grid-item': {
        padding: GRID_SPACING_COEFFICIENT * num / 2 + "px"
      }
    }, _assign));
    return accum;
  }, {});

  // we need to include entries for *all* classes that the underlying grid
  // component supports; otherwise we get console warnings when callers use
  // any of them

  // note that we're overriding the spacing-xs-* classes
  var gridClasses = {
    'container': {},
    'item': {},
    'zeroMinWidth': {},
    'direction-xs-column': {},
    'direction-xs-column-reverse': {},
    'direction-xs-row-reverse': {},
    'wrap-xs-nowrap': {},
    'wrap-xs-wrap-reverse': {},
    'spacing-xs-1': spacingClasses.spacingXS1,
    'spacing-xs-2': spacingClasses.spacingXS2,
    'spacing-xs-3': spacingClasses.spacingXS3,
    'spacing-xs-4': spacingClasses.spacingXS4,
    'spacing-xs-5': spacingClasses.spacingXS5,
    'spacing-xs-6': spacingClasses.spacingXS6,
    'spacing-xs-7': spacingClasses.spacingXS7,
    'spacing-xs-8': spacingClasses.spacingXS8,
    'spacing-xs-9': spacingClasses.spacingXS9,
    'spacing-xs-10': spacingClasses.spacingXS10,
    'grid-xs-auto': {},
    'grid-xs-true': {},
    'grid-xs-1': {},
    'grid-xs-2': {},
    'grid-xs-3': {},
    'grid-xs-4': {},
    'grid-xs-5': {},
    'grid-xs-6': {},
    'grid-xs-7': {},
    'grid-xs-8': {},
    'grid-xs-9': {},
    'grid-xs-10': {},
    'grid-xs-11': {},
    'grid-xs-12': {}
  };
  return gridClasses;
};

/**
 * Use `Grid` to create a responsive layout.
 * @done true
 * @updated v7.0.0
 * @versionAdded v0.1.2
 * @examples
 *  GridExample
 *  InteractiveFlexBoxExample
 */
var Grid = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(Grid, _Component);
  function Grid() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      spacing: 0
    };
    return _this;
  }
  var _proto = Grid.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.setSpacing();
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.spacing !== this.props.spacing) {
      this.setSpacing();
    }
  };
  _proto.setSpacing = function setSpacing() {
    var spacing = this.props.spacing;
    if (this.props.container) {
      switch (spacing) {
        case _globalSpacing.spacingVariant.STANDARD:
          this.setState({
            spacing: GRID_SPACING_STANDARD
          });
          break;
        case _globalSpacing.spacingVariant.NONE:
          this.setState({
            spacing: 0
          });
          break;
        default:
          this.setState({
            spacing: spacing
          });
      }
    }
  };
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _this$props = this.props,
      classes = _this$props.classes,
      className = _this$props.className,
      spacing = _this$props.spacing,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
    var propOverrides = this.props.container ? {
      spacing: this.state.spacing
    } : {};
    var gridClassName = this.props.container ? 'grid-container' : 'grid-item';
    return /*#__PURE__*/_react.default.createElement(_material.Grid, (0, _extends2.default)({}, rest, propOverrides, {
      classes: classes,
      className: className ? className + ' ' + gridClassName : gridClassName
    }));
  };
  return Grid;
}(_react.Component);
Grid.muiName = 'Grid';
Grid.propTypes = {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   * Options include: "stretch", "center", "flex-start", "flex-end", "space-between", "space-around".
   */
  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
  /**
   * Defines the `align-items` style property.
   * Options include: 'flex-start', 'center', 'flex-end', 'stretch', 'baseline'.
   */
  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])), _propTypes.default.number, _propTypes.default.object, _propTypes.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element, an component, or a function that returns a component.
   */
  component: _propTypes.default.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: _propTypes.default.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * Options include: "row", "row-reverse", "column", "column-reverse".
   */
  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: _propTypes.default.bool,
  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   * Options include: "flex-start", "center", "flex-end", "space-between", "space-around", "space-evenly".
    */
  justifyContent: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),
  /**
   * Defines the number of columns the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   * Options include: false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12.
   */
  lg: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of columns the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   * Options include: false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12.
   */
  md: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of columns the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   * Options include: false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12.
   */
  sm: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of columns the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   * Options include: false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12.
   */
  xl: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of columns the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   * Options include: false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12.
   */
  xs: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])), _propTypes.default.number, _propTypes.default.object, _propTypes.default.string]),
  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   * Options include: 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10.
   * Additional custom values include: `standard`, `none`.
   *
   * **NOTE:** Below are the value mappings for standard and none values:
   *
   * `standard` = 4
   *
   * `none` = 0
   */
  spacing: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 'standard', 'none']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * Options include: "nowrap", "wrap", "wrap-reverse".
   */
  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * https://material-ui.com/layout/grid/#limitations
   */
  zeroMinWidth: _propTypes.default.bool
};
Grid.defaultProps = {
  spacing: GRID_SPACING_STANDARD
};

// explicitly put grid at the back of the JSS style queue, so that the classes that consumers
// provide (via the classes prop) override out own settings
var _default = exports.default = (0, _styles.default)(styles, {
  index: 0
})(Grid);